import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const PreventiveMaintainanceWorkTableDataAPI = createAsyncThunk("PreventiveMaintainanceWorkTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_LocationID,
        M_WS_WorkTypeID,
        M_WS_WorkPeriodID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        handleGetPDFUrl,
        RoleID,
        handleMaintainanceWorkExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_Distri_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_Distri_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_MaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_WS_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_WS_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }


    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleMaintainanceWorkExport && handleMaintainanceWorkExport()
                handleGetPDFUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const PreventiveMaintainanceWorkTableDataSlice = createSlice({
    name: "PreventiveMaintainanceWorkTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PreventiveMaintainanceWorkTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PreventiveMaintainanceWorkTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PreventiveMaintainanceWorkTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PreventiveMaintainanceWorkTableDataReducer = PreventiveMaintainanceWorkTableDataSlice.reducer


export const PreventiveMaintainanceWorkTableExportDataAPI = createAsyncThunk("PreventiveMaintainanceWorkTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_LocationID,
        M_WS_WorkTypeID,
        M_WS_WorkPeriodID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        handleGetPDFUrl,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_Distri_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_Distri_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_MaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_WS_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_WS_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }


    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPDFUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const PreventiveMaintainanceWorkTableExportDataSlice = createSlice({
    name: "PreventiveMaintainanceWorkTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PreventiveMaintainanceWorkTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(PreventiveMaintainanceWorkTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(PreventiveMaintainanceWorkTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PreventiveMaintainanceWorkTableExportDataReducer = PreventiveMaintainanceWorkTableExportDataSlice.reducer

// -----------------Delete API ---------------

export const PreventiveMaintainanceWorkDeleteAPI = createAsyncThunk("PreventiveMaintainanceWorkDelete", async ({ data }) => {
    const {
        T_WS_MaintenanceServicesID,
        M_UserID,
        token,
        DashProjectTypeId,
        T_Distri_WaterMaintenanceServicesID,
        handleIsPost,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterMaintenanceServicesID", T_Distri_WaterMaintenanceServicesID);
    } else {
        formdata.append("T_WS_MaintenanceServicesID", T_WS_MaintenanceServicesID);
    }  
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterMaintenanceServices_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_MaintenanceServices_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const PreventiveMaintainanceWorkDeleteSlice = createSlice({
    name: "PreventiveMaintainanceWorkDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PreventiveMaintainanceWorkDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PreventiveMaintainanceWorkDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(PreventiveMaintainanceWorkDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PreventiveMaintainanceWorkDeleteReducer = PreventiveMaintainanceWorkDeleteSlice.reducer